import { render, staticRenderFns } from "./CreateBuildingsModal.vue?vue&type=template&id=c7617ff6&scoped=true"
import script from "./CreateBuildingsModal.vue?vue&type=script&lang=js"
export * from "./CreateBuildingsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateBuildingsModal.vue?vue&type=style&index=0&id=c7617ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7617ff6",
  null
  
)

export default component.exports